import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { FeatureFlagService } from '@app/services/feature-flag.service';
import { LocalStorageService } from '@app/services/local-storage.service';
import { LocaleService } from '@app/services/locale.service';
import { NavigationService } from '@app/services/navigation.service';
import { EmployeeService } from '@services/employee.service';
import { SelectEmployeeComponent as NewSelectEmployeeComponent } from '../../../../app/components/booking-steps/select-employee/select-employee.component';

@Component({
    selector: 'app-select-employee',
    templateUrl: './select-employee.component.html',
    styleUrls: ['./select-employee.component.scss'],
    standalone: false,
})
export class SelectEmployeeComponent extends NewSelectEmployeeComponent {
    constructor(
        private _employeeService: EmployeeService,
        private _fb: FormBuilder,
        private _localStorageService: LocalStorageService,
        private _featureFlagService: FeatureFlagService,
        private _navigationService: NavigationService,
        private _localeService: LocaleService
    ) {
        super(_employeeService, _fb, _localStorageService, _featureFlagService, _navigationService, _localeService);
    }
}
